import axios from 'axios';
import env from '../../env';

export const CountryService = {

    async getAll() {
        return axios.get(env.API + '/countries/all');
    },
}